import { validateCallback } from "../validateCallback";
import { rethrowNativeError } from "../nativeError";
import { audioNative as native } from "./hybrid.native";
import { AudioPlayer, createPlayer } from "./player.native";
var Audio = Object.freeze({
  getRecordingPermissionStatus: function getRecordingPermissionStatus() {
    return native().getRecordingPermissionStatus().catch(rethrowNativeError);
  },
  requestRecordingPermission: function requestRecordingPermission() {
    return native().requestRecordingPermission().catch(rethrowNativeError);
  },
  play: function play(uri) {
    return native().play(uri).catch(rethrowNativeError);
  },
  getPlaybackStatus: function getPlaybackStatus() {
    return native().getPlaybackStatus().catch(rethrowNativeError);
  },
  pause: function pause() {
    return native().pause().catch(rethrowNativeError);
  },
  resume: function resume() {
    return native().resume().catch(rethrowNativeError);
  },
  seek: function seek(positionMs) {
    return native().seek(positionMs).catch(rethrowNativeError);
  },
  stop: function stop() {
    return native().stop().catch(rethrowNativeError);
  },
  startRecording: function startRecording() {
    return native().startRecording().catch(rethrowNativeError);
  },
  getRecordingStatus: function getRecordingStatus() {
    return native().getRecordingStatus().catch(rethrowNativeError);
  },
  pauseRecording: function pauseRecording() {
    return native().pauseRecording().catch(rethrowNativeError);
  },
  resumeRecording: function resumeRecording() {
    return native().resumeRecording().catch(rethrowNativeError);
  },
  stopRecording: function stopRecording() {
    return native().stopRecording().catch(rethrowNativeError);
  },
  watchInterruptions: function watchInterruptions(onEvent) {
    validateCallback(onEvent, "Audio.watchInterruptions: onEvent must be a function");
    return native().addInterruptionListener(onEvent);
  },
  setNowPlayingInfo: function setNowPlayingInfo(info) {
    return native().setNowPlayingInfo(info).catch(rethrowNativeError);
  },
  clearNowPlayingInfo: function clearNowPlayingInfo() {
    return native().clearNowPlayingInfo().catch(rethrowNativeError);
  },
  watchRemoteCommands: function watchRemoteCommands(onEvent) {
    validateCallback(onEvent, "Audio.watchRemoteCommands: onEvent must be a function");
    return native().addRemoteCommandListener(onEvent);
  },
  AudioPlayer,
  createPlayer
});
export {
  Audio
};
//# sourceMappingURL=index.native.js.map
